// Hardcoded firebase config, do not edit
const config = {
  apiKey: "AIzaSyDx4ZG_1NQCjh_s6j6QF4XLcTg3u6SWto8",
  authDomain: "memegen-f235e.firebaseapp.com",
  projectId: "memegen-f235e",
  storageBucket: "memegen-f235e.firebasestorage.app",
  messagingSenderId: "194807682231",
  appId: "1:194807682231:web:0a4015488f3ebb869ea932",
  measurementId: "G-N89MRKFN8C",
};

// When deployed, there are quotes that need to be stripped
Object.keys(config).forEach((key) => {
  const configValue = config[key] + "";
  if (configValue.charAt(0) === '"') {
    config[key] = configValue.substring(1, configValue.length - 1);
  }
});

export const firebaseConfig = config;
